var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShuffleImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 4.88477H3.01109C3.56821 4.88475 4.11728 5.01773 4.61266 5.27265C5.10803 5.52756 5.5354 5.89705 5.85922 6.35039L8.14078 9.54414C8.4646 9.99748 8.89197 10.367 9.38734 10.6219C9.88272 10.8768 10.4318 11.0098 10.9889 11.0098H12.6875",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 3.57227L12.6875 4.88477L11.375 6.19727",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 9.69727L12.6875 11.0098L11.375 12.3223",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0752 6.44172L8.14082 6.35039C8.46464 5.89705 8.89201 5.52756 9.38738 5.27265C9.88276 5.01773 10.4318 4.88475 10.9889 4.88477H12.6875",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 11.0096H3.01109C3.56821 11.0096 4.11728 10.8766 4.61266 10.6217C5.10803 10.3668 5.5354 9.9973 5.85922 9.54396L5.92484 9.45264",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffleImg);
export default __webpack_public_path__ + "static/media/shuffle-img.e69bfba95ccaf7b0d6a8fb2626fb0548.svg";
export { ForwardRef as ReactComponent };